import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#07151c] pt-10 pb-6 border-t border-white/5" data-id="element-152" data-mp="3geze367ujv27">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153" data-mp="3gh3q6bfwg0dk">
        <div className="text-center mb-6" data-id="element-154" data-mp="32p5lqdx4usnq">
          <h2 className="text-xl font-display font-black text-white mb-2" data-id="element-155" data-mp="36pfshssr1n3n">🧘 STRETCHING 360™</h2>
          <p className="text-gray-400 text-sm max-w-2xl mx-auto" data-id="element-156" data-mp="36n3gdw9oa6yi">
            El sistema completo para profes de Stretching en Argentina. Planificá mejor, enseñá con seguridad y recuperá tus noches.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-6 text-sm" data-id="element-157" data-mp="3levhp4cmtkh8">
          <a href="mailto:contacto@recursosfitness.shop" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-158" data-mp="3qcnjcq32wkym">
            <MailIcon className="w-4 h-4 mr-1.5" data-id="element-159" data-mp="2a19sxkaopkw8" /> contacto@recursosfitness.shop
          </a>
          <a href="#" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-160" data-mp="2ezl4q0kji5h3">@recursosfitness.ar</a>
          <a href="https://recursosfitness.shop" className="flex items-center text-gray-300 hover:text-brand-accent transition-colors" data-id="element-161" data-mp="3gah29wtj3p7f">
            <GlobeIcon className="w-4 h-4 mr-1.5" data-id="element-162" data-mp="3v8rf7oxh4xv4" /> recursosfitness.shop
          </a>
        </div>

        <div className="text-center text-gray-500 text-xs border-t border-white/5 pt-5" data-id="element-163" data-mp="3q7lqs3aujwre">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
}